import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { NotificationEvent } from '@nucleus-commerce/api-client/admin';

import { notificationsApi } from '../api/notifications-api';

import { notificationKeys } from './notification-keys';

/**
 * Renders a draft with the backend's sample data. Idempotent, so it is a query keyed by the
 * draft; the editor debounces the draft before it gets here. Blank fields render the default.
 */
export function useTemplatePreview(
  storeId: string,
  event: NotificationEvent,
  draft: { subject: string | null; body: string | null },
  enabled: boolean,
) {
  return useQuery({
    enabled,
    queryKey: notificationKeys.preview(storeId, event, draft),
    queryFn: () => notificationsApi.preview(storeId, event, draft),
    placeholderData: keepPreviousData,
    retry: false,
    staleTime: 60_000,
  });
}
